export default "__VITE_ASSET__CLUjFWFn__"